import React, { Component } from "react";
import { connect } from "react-redux";
import AdSense from "react-adsense";

class Publi extends Component {
  render() {
    return (
      <div>
        <br />
        <br />
        <AdSense.Google client="ca-pub-1432281280543089" slot="2677980562" />
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Publi);



// WEBPACK FOOTER //
// ./src/components/Publi.js